import { Routes } from '@angular/router'

export const projectManagementRoutes: Routes = [
    {
        path: 'project-management',
        children: [],
    },
]
